import { Injectable } from '@angular/core';
import { Observable, Subscribable, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public notification=new Subject<any>();
  public notificationContents:any;

  constructor() { }

  public showMessage(message:string, action:string){
    this.notification.next([message, action]);
  }
}
